import { render, staticRenderFns } from "./HowToRelease.vue?vue&type=template&id=49b68cff&scoped=true"
import script from "./HowToRelease.vue?vue&type=script&lang=js"
export * from "./HowToRelease.vue?vue&type=script&lang=js"
import style0 from "./HowToRelease.vue?vue&type=style&index=0&id=49b68cff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b68cff",
  null
  
)

export default component.exports